module.exports = __webpack_public_path__ + "assets/be672c9483cb94682e9c7b4c0eef149c.svg";